import { ReactElement } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { featureFlagsModel } from '../../../../models/entities/businessPartner/settings';
import claimsType from '../../../../models/entities/claimsType';
import { localizationSelectors } from '../../../../state/ducks/localization/selectors';
import { userSelectors } from '../../../../state/ducks/user/selectors';
import { RootState } from '../../../../state/store/store';
import { claimsDomainsType } from '../../../../userClaims';
import { DropDown } from '../../../shared/inputs/base';
import renderStateOption from '../../../shared/SmallComponents/StateOption';

type Props = {
    updateState: (state: string) => Promise<void>;
    featureFlags?: featureFlagsModel;
    localizations?: any;
    getUserClaims: (domain: claimsDomainsType) => claimsType;
    settingsState?: [{ code: string; name: string; description: string; displayOrder: number; color: string; toolTipText?: string }];
};

const ShipmentStateSelect = ({ updateState, featureFlags, localizations, getUserClaims, settingsState }: Props) => {
    return (
        <StyledDropdownWrapper>
            <DropDown
                placeHolder={localizations.shipment_state}
                options={
                    settingsState
                        ?.sort((a, b) => a.displayOrder - b.displayOrder)
                        .map((item) => ({
                            text: item.name,
                            value: item.code,
                            color: item.color
                        })) || []
                }
                optionRenderer={renderStateOption}
                onChange={async (value: string) => {
                    await updateState(value);
                }}
                disabled={featureFlags?.UNDER_FORWARDER || !getUserClaims('shipment').edit_state}
                verifyChange={{
                    title: (value: string) => `${localizations.you_are_moving_the_shipment_state_to} ${
                        settingsState?.find((item) => item.code === value)?.name
                    }.
                                    ${localizations.are_you_sure}`
                }}
            />
        </StyledDropdownWrapper>
    );
};

const StyledDropdownWrapper = styled.div`
    & .ant-select-selector {
        background-color: white !important;
        border-color: rgba(255, 255, 255, 0.5) !important;
    }
    
    & .ant-select-selection-item {
        color: #333 !important;
    }
    
    & .ant-select-focused .ant-select-selector {
        border-color: white !important;
        box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2) !important;
    }
    
    & .ant-select-arrow {
        color: rgba(255, 255, 255, 0.8) !important;
    }
    
    & .ant-select-selection-placeholder {
        color: rgba(0, 0, 0, 0.5) !important;
    }
    
    & .ant-select-dropdown {
        background: white !important;
        border: 1px solid #d9d9d9;
        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05) !important;
    }
    
    & .ant-select-item {
        background: white !important;
        color: #333 !important;
    }
    
    & .ant-select-item:hover {
        background: #f5f5f5 !important;
    }
    
    & .ant-select-item-option-selected {
        background: #e6f7ff !important;
        color: #1890ff !important;
    }
`;

const mapStateToProps = (state: RootState) => ({
    isFreelancerOrForwarder: userSelectors.isFreelancerOrForwarder(state),
    featureFlags: userSelectors.featureFlags(state),
    localizations: localizationSelectors.singleShipmentPage(state),
    getUserClaims: (domain: claimsDomainsType) => userSelectors.getUserClaims(state)(domain)
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentStateSelect);
